import { render, staticRenderFns } from "./GoogleFactcheckTools.vue?vue&type=template&id=d8e9085a"
import script from "./GoogleFactcheckTools.vue?vue&type=script&lang=ts"
export * from "./GoogleFactcheckTools.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports